import { useSelector } from 'react-redux';
import { TUserInfoTypes } from '@/types/redux_type';

export default function useGetUserInfo(): TUserInfoTypes {
  return useSelector<{ userInfo: TUserInfoTypes }, TUserInfoTypes>((state) => {
    return state.userInfo;
  });
}
